<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
  >
    <defs>
      <path
        d="M19.0298697,16.9128088 L15.0180725,12.9011754 C15.9848792,11.5055326 16.4685284,9.94967017 16.4685284,8.23440756 C16.4685284,7.11938445 16.252062,6.05298845 15.8191292,5.03546534 C15.3864832,4.01777836 14.8016061,3.14060609 14.0647437,2.4037437 C13.3278813,1.6668813 12.4508319,1.0820042 11.4333498,0.649317227 C10.4155399,0.216507353 9.34922584,0.00012289916 8.23420273,0.00012289916 C7.11926155,0.00012289916 6.05286555,0.216507353 5.03534244,0.649317227 C4.01765546,1.0820042 3.14048319,1.6668813 2.4036208,2.4037437 C1.66667647,3.14060609 1.0818813,4.01794223 0.649153361,5.03546534 C0.216384454,6.05311134 0,7.11938445 0,8.23440756 C0,9.34934874 0.216384454,10.4153761 0.649153361,11.4331859 C1.08184034,12.450709 1.66667647,13.3277584 2.4036208,14.0646208 C3.14048319,14.801729 4.01781933,15.3863603 5.03534244,15.8192931 C6.05298845,16.252021 7.11926155,16.4683645 8.23420273,16.4683645 C9.94983403,16.4683645 11.5054506,15.9846744 12.9011754,15.0179496 L16.9129727,19.0179485 C17.1936744,19.3141765 17.5441008,19.4623929 17.9655221,19.4623929 C18.3709664,19.4623929 18.7220483,19.3142174 19.0181124,19.0179485 C19.3142994,18.7217616 19.4625158,18.3708435 19.4625158,17.9653992 C19.4625158,17.5523761 19.318396,17.2013351 19.0298697,16.9128088 Z M11.9360893,11.9358845 C10.9107416,12.961396 9.676875,13.4741313 8.23420273,13.4741313 C6.79177626,13.4741313 5.55790966,12.9612731 4.53248004,11.9358845 C3.50705042,10.9105368 2.99435609,9.67683403 2.99435609,8.23416176 C2.99435609,6.79173529 3.50717332,5.55766387 4.53248004,4.53243908 C5.55770483,3.50696849 6.79177626,2.99431513 8.23420273,2.99431513 C9.67671113,2.99431513 10.9105777,3.50717332 11.9360893,4.53243908 C12.9616008,5.55766387 13.4742952,6.79173529 13.4742952,8.23416176 C13.4742952,9.67683403 12.961437,10.9105368 11.9360893,11.9358845 Z"
        id="path-1"
      ></path>
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        class="symbol"
        transform="translate(-1188.000000, -133.000000)"
        fill-rule="nonzero"
      >
        <g
          id="magnifying-glass-(1)"
          transform="translate(1188.000000, 133.000000)"
        >
          <g id="Shape">
            <use xlink:href="#path-1"></use>
            <use xlink:href="#path-1"></use>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgIconSearch'
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/js/svgs/SvgIconSearch.vue